import { Box, Skeleton, Typography } from '@mui/material';
import React from 'react';
import useWiseconnFarmsCount from '../hooks/useWiseconnFarmsCount';

const FarmsCounter: React.FC = () => {
  const {
    dbCount, wiseconnCount, loading, wiseconnError,
  } = useWiseconnFarmsCount();

  const renderValue = (value: number | null, showDash: boolean) => {
    if (loading) return <Skeleton width={28} sx={{ display: 'inline-block' }} />;
    if (value === null) return showDash ? '—' : 0;
    return value;
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        border: '1px solid #e0e0e0',
        borderRadius: 2,
        px: 2,
        py: 1,
        backgroundColor: '#f9f9f9',
        width: '300px',
      }}
    >
      <Typography variant="body2" sx={{ color: '#385576', fontWeight: 530 }}>
        Campos BDD / Wiseconn:
      </Typography>
      <Typography variant="h6" sx={{ fontWeight: 700, color: '#385576' }}>
        {renderValue(dbCount, false)} / {renderValue(wiseconnCount, wiseconnError)}
      </Typography>
    </Box>
  );
};

export default FarmsCounter;
